module.exports = __webpack_public_path__ + "images/mercedesbenz23ae0ecbc3104e39f80068b61f20bb4c.png";